import CourseListingPage from "./courseListingPage"

export default CourseListingPage;